import React from "react";
import { MdArrowBackIosNew } from "react-icons/md";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import useTours from "./hooks/useTours";
import SingleConcert from "./singleConcert";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useNavigate } from "react-router-dom";
import { CUSTOM_OFFER } from "../../routes";

const TourDetails: React.FC = () => {
  const { t } = useTranslation();
  const { exercises, navigateToTourSale, loading, exerciseName, exerciseDescription, saleStepId } = useTours();
  const navigate = useNavigate();
  const customOffers = useSelector((state: State) => state.stepSaleConfig.customOffers);

  // Znajdź saleStep, aby sprawdzić czy pochodzi z CustomOffer
  const isFromCustomOffer = !!saleStepId;

  // Funkcja nawigacji, która obsługuje powrót do CustomOffer
  const handleBack = () => {
    if (isFromCustomOffer) {
      // Znajdź offerId dla danego saleStepId
      let foundOfferId = "";
      customOffers.forEach((offer) => {
        if (offer.saleSteps.some((step) => step.id === saleStepId)) {
          foundOfferId = offer.stepId;
        }
      });

      if (foundOfferId) {
        // Nawiguj z powrotem do CustomOffer z odpowiednim offerId
        navigate(`${CUSTOM_OFFER}?offerId=${foundOfferId}`);
      } else {
        // Awaryjnie nawiguj do głównej strony TourSale
        navigateToTourSale();
      }
    } else {
      // Standardowa nawigacja dla zwykłego TourSale
      navigateToTourSale();
    }
  };

  if (loading) {
    return <EASkeletonLoader height="400px" />;
  }

  if (exercises.length <= 0) {
    return <div className="alert alert-yellow">Nie znaleziono wydarzeń.</div>;
  }

  return (
    <>
      <div className="modal-window-header flex-start">
        <EAButton title={t("wroc")} onClick={handleBack} startIcon={<MdArrowBackIosNew />} variant="text" />
        <div>
          <h1>
            {t("kup_bilet")}:<b>{exerciseName}</b>
          </h1>
          <article dangerouslySetInnerHTML={{ __html: exerciseDescription }}></article>
        </div>
      </div>

      <div>
        {exercises && (
          <div>
            {exercises.map((item, index) => (
              <div className={"event-block"} key={index}>
                <SingleConcert item={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TourDetails;
